import React from "react";
import { Link } from "react-router-dom";

export default function PaymentFail() {
  return (
    <div
      style={{
        textAlign: "center",
        marginTop: "80px",
        padding: "20px",
      }}
    >
      <h1>Payment Failed ❌</h1>

      <p>
        Your payment could not be completed or was cancelled.
      </p>

      <Link to="/">
        <button
          style={{
            marginTop: "20px",
            padding: "12px 20px",
            cursor: "pointer",
          }}
        >
          Try Again
        </button>
      </Link>
    </div>
  );
}
